import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private messageService: MessageService) { }

  async createExcel(rows: any[], name: string) {
    const XLSX = await import('xlsx');
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(rows);
  
    XLSX.utils.book_append_sheet(workbook, worksheet, name);
  
    // Generate the Excel file buffer
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
  
    return excelBuffer;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver-es").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(
        data,
        fileName + EXCEL_EXTENSION
      );
      this.messageService.clear('bc');
      this.messageService.add({ severity: 'success', summary: 'Success', key: 'bc', detail: 'The file has been downloaded', life: 3000 });
    });
  };
}
